import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
`

const StyledInput = styled.input`
  outline: none;
  z-index: 1;
  position: relative;
  background: none;
  width: 100%;
  height: 32px;
  border: 0;
  color: #212121;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;

  &:focus {
    ~ label {
      color: #9d9d9d;
      transform: translate(-12%, -75%) scale(0.75);
    }

    ~ .bar {
      &:before{
        width: 100%;
      }
    }
  }

  &:valid {
    ~ label {
      color: #9d9d9d;
      transform: translate(-12%, -75%) scale(0.75);
    }
  }
`
const StyledLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  color: #4D4D4D;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  transition: 0.2s ease;
`
const Bar = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  background: #232323;
  width: 100%;
  height: 1px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    background: $color-brand;
    width: 0;
    height: 1px;
    transition: 0.2s ease;
  }

  &:before {
    left: 0;
  }
`
const OneLineInput = (props) => (
    <Wrap>
        <StyledInput id={props.id} type={props.type} required={props.required} />
        <StyledLabel for={props.id}>{props.label}</StyledLabel>
        <Bar/>
    </Wrap>
)

export default OneLineInput



// WEBPACK FOOTER //
// ./src/components/Form/OneLineInput.js